/* D'AZUR — header flutuante ("pílula") depois de passar o header; no topo fica o header normal.
   Independente do sticky do tema: a classe .dzr-hdr-float em .section-header muda o .header-wrapper
   para position:fixed (CSS em dzr-header.css). O espaço do header em fluxo é preservado com min-height. */
(function () {
  if (window.__dzrHeader) return; window.__dzrHeader = true;

  var sec, wrap, html = document.documentElement;
  var floating = false, secTop = 0, wrapH = 0, secH = 0, raf = 0;
  var HYST = 8;

  function measure() {
    if (floating) return;
    var r = sec.getBoundingClientRect();
    secTop = r.top + window.scrollY;
    wrapH = wrap.offsetHeight;
    secH = sec.offsetHeight;
  }
  function enter() {
    floating = true;
    if (secH > 0) sec.style.minHeight = secH + 'px';
    sec.classList.add('dzr-hdr-float');
    html.classList.add('dzr-hdr-float');
    syncOpen();
  }
  function leave() {
    floating = false;
    sec.classList.remove('dzr-hdr-float', 'dzr-hdr-open');
    html.classList.remove('dzr-hdr-float');
    sec.style.minHeight = '';
    measure();
  }
  function update() {
    raf = 0;
    var y = window.scrollY;
    var bottom = secTop + wrapH;
    if (!floating && y > bottom + HYST) enter();
    else if (floating && y < bottom - HYST) leave();
  }
  function req() { if (!raf) raf = requestAnimationFrame(update); }

  // menu (drawer) ou pesquisa abertos → a pílula abre para barra cheia
  function syncOpen() {
    var open = wrap.querySelector('header-drawer details[open], .header__search details[open]');
    sec.classList.toggle('dzr-hdr-open', !!open);
  }

  // altura do header no fluxo pode mudar (fontes, imagens, resize): remedir fora do estado flutuante
  function remeasure() { if (floating) return; measure(); req(); }

  function init() {
    sec = document.querySelector('.section-header');
    wrap = sec && sec.querySelector('.header-wrapper');
    if (!sec || !wrap) return;
    measure();
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', remeasure);
    window.addEventListener('load', remeasure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
    wrap.addEventListener('toggle', function (e) {
      if (e.target && e.target.tagName === 'DETAILS') syncOpen();
    }, true);
    // seletor de país (bandeira): submete o form ao mudar
    document.addEventListener('change', function (e) {
      var s = e.target && e.target.closest ? e.target.closest('.dzr-flag__select') : null;
      if (!s) return;
      var f = s.closest('form');
      if (f) f.submit();
    });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
